import useDynamicNavigation from './useDynamicNavigation'

export default useDynamicNavigation
